<div>
    <input-label [label]="label"></input-label>
    <p-dropdown [options]="options" [formControl]="control" styleClass="w-100" [filter]="true"></p-dropdown>
</div>
